module.exports = __webpack_public_path__ + "static/media/400021_01.b172f678.png";